/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Delete_Selected_AriaInputs */



/**
* | output |
* | --- |
* | "Delete Selected" |
*
* @param {Explorer_Display_Delete_Selected_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_delete_selected_aria = /** @type {((inputs?: Explorer_Display_Delete_Selected_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Delete_Selected_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la selection")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить выбранное")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除所选内容")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択項目を削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित को हटाओ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir selecionados")
	return /** @type {LocalizedString} */ ("Delete Selected")
});